<template>
  <v-card class="pa-2">
    <v-row dense class="ma-0 d-flex justify-end">
      <v-btn
        depressed
        color="#0f3565"
        dark
        class="mr-0 hidden-sm-and-down primary-button"
        @click="filtersVisible = !filtersVisible"
      >
        Filtros
      </v-btn>
    </v-row>
    <v-expand-transition>
      <div v-if="filtersVisible">
        <v-row dense class="ma-0" align="center" justify="end">
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Nº O.S.') }}</label>
            <v-text-field
              v-model="filter.number"
              class="primary-input"
              style="max-width: 270px"
              outlined
              hide-details
              placeholder="Pesquisar por Nº O.S."
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Nome O.S.') }}</label>
            <v-text-field
              v-model="filter.name"
              class="primary-input"
              style="max-width: 270px"
              outlined
              hide-details
              placeholder="Pesquisar por nome O.S."
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <label class="label">{{ $t('Unidade') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="filter.unidadeId"
              :items="unidades"
              item-value="id"
              item-text="name"
              :loading="unidadeLoading"
              outlined
              class="primary-input"
              placeholder="Todas"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <label class="label">{{ $t('Setor') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="filter.departmentIds"
              :items="localDepartments"
              multiple
              item-value="id"
              item-text="name"
              :loading="departmentLoading"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
              :search-input.sync="search"
              @blur="search = ''"
              clearable
              chips
              deletable-chips
              small-chips
            >
              <template
                v-slot:selection="{ attrs, index, item, select, selected }"
              >
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  color="#BBCF20"
                  text-color="#fff"
                  small
                  @click="select"
                  @click:close="removeDepartment(index)"
                >
                  {{ item.name }}
                </v-chip>
              </template>

              <template v-slot:item="{ item }">
                <span class="text-caption" v-if="item.unidade">
                  {{ item.name }} / {{ item.unidade.name }}
                </span>
                <span class="text-caption" v-else>
                  {{ item.name }}
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Equipamento Padrão') }}</label>
            <v-autocomplete
              v-model="filter.standardEquipmentId"
              :items="standardEquipments"
              item-text="name"
              item-value="id"
              class="primary-input"
              append-icon="mdi-chevron-down"
              style="max-width: 270px"
              outlined
              hide-details
              placeholder="Pesquisar por Equipamento Padrão"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Equip. ID.') }}</label>
            <v-text-field
              v-model="filter.identification"
              class="primary-input"
              style="max-width: 270px"
              outlined
              hide-details="true"
              placeholder="Pesquisar por Equip. ID."
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              ref="menuStartDate"
              v-model="menuStartDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <div>
                  <label class="label">{{ $t('Solicitação Inicial') }}</label>
                  <v-text-field
                    hide-details="auto"
                    v-model="startDate"
                    v-mask="['##/##/####']"
                    placeholder="Solicitação Inicial"
                    prepend-inner-icon="mdi-calendar"
                    @blur="filter.requestStartDate = parseDate(startDate)"
                    v-bind="attrs"
                    v-on="on"
                    autocomplete="off"
                    outlined
                    class="primary-input"
                  ></v-text-field>
                </div>
              </template>
              <v-date-picker
                v-model="filter.requestStartDate"
                min="1900-01-01"
                @change="saveRequestDate"
                no-title
                locale="pt"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              ref="menuEndDate"
              v-model="menuEndDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <div>
                  <label class="label">{{ $t('Solicitação Final') }}</label>
                  <v-text-field
                    hide-details="auto"
                    v-model="endDate"
                    placeholder="Solicitação Final"
                    v-mask="['##/##/####']"
                    prepend-inner-icon="mdi-calendar"
                    @blur="filter.requestEndDate = parseDate(endDate)"
                    v-bind="attrs"
                    v-on="on"
                    autocomplete="off"
                    outlined
                    class="primary-input"
                  ></v-text-field>
                </div>
              </template>
              <v-date-picker
                class="ma-0"
                v-model="filter.requestEndDate"
                @change="saveRequestDate"
                locale="pt"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Tipo O.S.') }}</label>
            <v-autocomplete
              hide-details
              clearable
              v-model="filter.serviceOrderTypes"
              :items="serviceOrderTypes"
              multiple
              placeholder="Tipo O.S."
              item-text="text"
              item-value="value"
              outlined
              class="primary-input"
              append-icon="mdi-chevron-down"
              @keyup.enter="list"
            >
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  color="#BBCF20"
                  text-color="#fff"
                  small
                  @click="select"
                  @click:close="removeServiceOrderType(item)"
                >
                  <span class="text-caption" style="text-transform: none">
                    {{ $t(item.text) }}
                  </span>
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-btn class="primary-button ma-1 mb-4" depressed @click="list">
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>

    <v-expand-transition>
      <div class="d-flex justify-end" v-if="downloadList.length > 0">
        <v-btn depressed class="secondary-button" @click="getZip">
          Baixar arquivos ({{ downloadList.length }} selecionados)
        </v-btn>
      </div>
    </v-expand-transition>

    <v-data-table
      :loading="loading"
      :loading-text="$t('Carregando...')"
      :no-data-text="$t('Nenhuma arquivo encontrado')"
      :headers="headers"
      :items="files"
      class="main-table"
      hide-default-footer
      :items-per-page="filter.pageSize"
      :header-props="headerProps"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
    >
      <template #[`header.checkbox`]>
        <div class="d-flex justify-center align-center">
          <v-checkbox
            dense
            dark
            hide-details
            :value="downloadList.length == filesNumber"
            @click="selectAll"
          ></v-checkbox>
        </div>
      </template>

      <template #[`item.serviceOrderType`]="{ item }">
        {{
          item.serviceOrderType
            ? $t(serviceOrderTypes[item.serviceOrderType].text)
            : $t('Sem registro')
        }}
      </template>

      <template #[`item.dateTimeRequest`]="{ item }">
        {{
          item.dateTimeRequest
            ? formatDate(item.dateTimeRequest)
            : $t('Sem registro')
        }}
      </template>

      <template #[`item.checkbox`]="{ item }">
        <div class="d-flex justify-center">
          <v-checkbox
            dense
            v-model="item.selected"
            @click="addAllToDownloadList(item)"
          ></v-checkbox>
        </div>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <table class="main-table" style="width: 100%">
            <thead>
              <tr>
                <th>
                  <v-icon color="white">mdi-download</v-icon>
                </th>
                <th
                  style="
                    min-width: unset !important;
                    width: unset !important;
                    max-width: unset !important;
                  "
                  class="pa-2"
                >
                  Nome do arquivo
                </th>
                <th class="pa-2">Tipo de arquivo</th>
                <th class="pa-2">Data do Upload</th>
                <th class="pa-2">Ações</th>
              </tr>
            </thead>
            <tr v-for="file in item.uploadDocuments" :key="file.id">
              <td>
                <v-checkbox
                  v-model="file.selected"
                  @click="addToDownloadList(file)"
                ></v-checkbox>
              </td>
              <td
                style="
                  min-width: unset !important;
                  width: unset !important;
                  max-width: unset !important;
                "
                class="text-center"
              >
                {{ file.name }}
              </td>
              <td class="text-center">.{{ file.fileType }}</td>
              <td class="text-center">{{ formatDate(file.uploadDate) }}</td>
              <td class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="primary-button"
                      tile
                      small
                      depressed
                      @click="getFile(file)"
                    >
                      <v-icon>mdi-open-in-new</v-icon>
                    </v-btn>
                  </template>
                  <span>Abrir documento</span>
                </v-tooltip>
              </td>
            </tr>
          </table>
        </td>
      </template>
    </v-data-table>

    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="totalItensOnPage">
          <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="3"
        ></v-pagination>
      </div>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import GeneralService from '../../../../services/GeneralService'
import moment from 'moment'

export default {
  name: 'repositoryOrders',

  data() {
    return {
      filtersVisible: false,
      localDepartments: [],
      departments: [],
      unidadeLoading: false,
      unidades: [],
      page: 1,
      requestMinDate: null,
      typeOSSearch: null,
      serviceOrderTypeSelected: [],
      totalPages: null,
      totalItensOnPage: 0,
      totalItems: 0,
      pageSize: 10,
      sizes: [10, 30, 90, 180],
      generalService: new GeneralService(),
      downloadList: [],
      expanded: [],
      menuStartDate: false,
      menuEndDate: false,
      startDate: null,
      search: '',
      endDate: null,
      singleExpand: true,
      serviceOrderTypes: [
        { text: 'Treinamento', value: 0 },
        { text: 'Segurança elétrica', value: 1 },
        { text: 'Preventiva', value: 2 },
        { text: 'Instalação', value: 3 },
        { text: 'Rotina de Inspeção', value: 4 },
        { text: 'Corretiva', value: 5 },
        { text: 'Calibração', value: 6 },
        { text: 'Validação/Qualificação', value: 7 },
        { text: 'Serviço Administrativo', value: 8 },
        { text: 'Empréstimo', value: 9 },
      ],
      headers: [
        {
          text: 'Seleção',
          align: 'center',
          value: 'checkbox',
          sortable: false,
          width: 40,
        },
        {
          text: 'Nº O.S.',
          align: 'center',
          value: 'number',
          sortable: false,
        },
        {
          text: 'Nome O.S.',
          align: 'center',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Tipo O.S.',
          align: 'center',
          value: 'serviceOrderType',
          active: true,
          width: 60,
        },
        {
          text: 'Solicitação',
          align: 'center',
          value: 'dateTimeRequest',
          sortable: false,
        },
        {
          text: 'Equipamento Padrão',
          align: 'center',
          value: 'equipment.standardEquipment.name',
          sortable: false,
        },
        {
          text: 'Equip. ID.',
          align: 'center',
          value: 'equipment.identification',
          sortable: false,
        },
      ],
      apiService: new ApiService(),
      loading: false,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      filter: {
        page: 1,
        pageSize: 10,
        requestStartDate: null,
        requestEndDate: null,
      },
      files: [],
      standardEquipments: [],
      departmentLoading: false,
    }
  },

  computed: {
    filesNumber() {
      let filesCount = 0

      this.files.forEach((item) => {
        filesCount += item.uploadDocuments.length
      })

      return filesCount
    },
  },

  async created() {
    this.list()
    this.getStandardEquipments()

    const userLogged = JSON.parse(localStorage.getItem('user'))
    const institution = JSON.parse(localStorage.getItem('institution'))

    if (institution.userType > 1) {
      await this.getUserUnidades()
    } else {
      await this.getUnidades()
    }

    this.getDepartments()
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        if (this.filter.unidadeId) {
          this.localDepartments = this.departments.filter(
            (x) => x.unidadeId == this.filter.unidadeId
          )
        } else {
          this.localDepartments = this.departments.filter((x) =>
            this.unidades.map((x) => x.id).includes(x.unidadeId)
          )
        }
      },
    },

    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = 1
      this.list()
    },

    page() {
      this.filter.page = this.page
      this.list()
    },
  },

  methods: {
    removeDepartment(item) {
      this.filter.departmentIds.splice(item, 1)
      this.filter.departmentIds = [...this.filter.departmentIds]
    },

    async getDepartments() {
      this.departmentLoading = true
      const institutionId = JSON.parse(localStorage.getItem('institution')).id

      await this.apiService
        .get(`department/listActive/${institutionId}`)
        .then((response) => {
          this.departments = response.content
          this.localDepartments = this.departments.filter((x) =>
            this.unidades.map((x) => x.id).includes(x.unidadeId)
          )
          this.departmentLoading = false
        })
    },

    async getUserUnidades() {
      this.unidadeLoading = true
      const institutionId = JSON.parse(localStorage.getItem('institution')).id

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getUnidades() {
      this.unidadeLoading = true
      const institutionId = JSON.parse(localStorage.getItem('institution')).id

      await this.apiService
        .get(`unidade/list/${institutionId}`)
        .then((response) => {
          this.unidades = response.content
        })
      this.unidadeLoading = false
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    saveRequestDate(date) {
      this.startDate = this.formatInputDate(this.filter.requestStartDate)
      this.$refs.menuStartDate.save(date)
      this.requestMinDate = new Date(this.filter.requestStartDate)
        .toISOString()
        .substr(0, 10)
      this.endDate = this.formatInputDate(this.filter.requestEndDate)
      this.$refs.menuEndDate.save(date)
    },

    removeServiceOrderType(item) {
      this.filter.serviceOrderTypes = this.filter.serviceOrderTypes.filter(
        (x) => x != item.value
      )
    },

    selectAll() {
      this.files.forEach((item) => {
        item.selected = false
        item.uploadDocuments = item.uploadDocuments.map((x) => {
          return {
            ...x,
            selected: false,
          }
        })
      })

      if (this.downloadList.length == this.filesNumber) {
        this.downloadList = []
        return
      }

      const ids = this.downloadList.map((x) => x.id)
      this.files.forEach((item) => {
        const downloadsToPush = item.uploadDocuments.filter(
          (x) => !ids.includes(x.id)
        )
        this.downloadList.push(...downloadsToPush)

        item.selected = true
        item.uploadDocuments = item.uploadDocuments.map((x) => {
          return {
            ...x,
            selected: true,
          }
        })
      })
    },

    async getStandardEquipments() {
      this.standardEquipmentLoading = true

      const institutionId = JSON.parse(localStorage.getItem('institution')).id

      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          institutionId
        )
      this.standardEquipmentLoading = false
    },

    getFile(document) {
      if (document.filePath) {
        if (document.filePath.includes('equipacarefix.blob.core')) {
          const url = document.filePath
          window.open(url)
        } else {
          const url =
            process.env.VUE_APP_BASE_URL +
            document.filePath.replace('wwwroot/', '')
          window.open(url)
        }
      } else {
        this.getDocument(document)
      }
    },

    async getDocument(document) {
      await this.apiService
        .get(`uploadDocument/${document.id}`)
        .then((response) => {
          const fileWindow = window.open()
          const url = 'data:application/pdf;base64,' + response.content.filepath

          fileWindow.document.write(
            `<html>
              <title>${document.fileName}.${document.fileType}</title>
              <body style:"overflow: hidden; margin: 0">
                <object width="100%" width="-webkit-fill-available" height="100%" height="-webkit-fill-available" type="application/pdf" data="${url}"></object>
              </body>
            </html>`
          )
        })
    },

    addAllToDownloadList(item) {
      if (item.selected) {
        this.downloadList.push(...item.uploadDocuments)
        item.uploadDocuments = item.uploadDocuments.map((x) => {
          return {
            ...x,
            selected: true,
          }
        })
      } else {
        this.downloadList = this.downloadList.filter(
          (x) => !item.uploadDocuments.map((y) => y.id).includes(x.id)
        )
        item.uploadDocuments = item.uploadDocuments.map((x) => {
          return {
            ...x,
            selected: false,
          }
        })
      }
    },

    addToDownloadList(file) {
      if (file.selected) this.downloadList.push(file)
      else this.downloadList = this.downloadList.filter((x) => x.id != file.id)
    },

    formatDate(date) {
      return date ? moment(date).format('DD/MM/yyyy HH:mm') : 'Sem registros'
    },

    async getZip() {
      if (this.downloadList.length > 25) {
        this.$toast.warning('Máximo de 25 arquivos por vez')
        return
      }
      this.$toast(
        `${this.$t('Imprimindo registros')}: ${
          this.downloadList.length
        } ${this.$t('selecionados')}`
      )
      const ids = this.downloadList.map((x) => x.id)

      await this.apiService
        .post(`serviceOrder/files/zip`, { ids })
        .then((response) => {
          var pedfResult = 'data:application/zip;base64,' + response.content
          const link = document.createElement('a')
          link.href = pedfResult
          link.setAttribute('download', `arquivos_em_lote`)
          document.body.appendChild(link)
          link.click()
          this.downloadList = []
        })
    },

    list() {
      const institution = localStorage.getItem('institution')
      this.filter.institutionId = institution ? JSON.parse(institution).id : ''
      this.loading = true

      this.apiService
        .post('serviceOrder/files', this.filter)
        .then((response) => {
          this.files = response.content.serviceOrders
          this.totalPages = response.content.pager.totalPages
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.serviceOrders.length
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style></style>
